import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

const FeeItems = ({ feeItems, editable, removeFeeItems, handleFeeItemsChange }) => {

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newFeeItems = [...feeItems];
    newFeeItems[index] = { ...newFeeItems[index], [key]: value };
    handleFeeItemsChange(index, newFeeItems[index]);
  };

  const actionTemplate = (rowData, column) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => removeFeeItems(column.rowIndex)} />;
  };


  return (
    <>
      
          <DataTable value={feeItems} size="small" editMode="cell">
            <Column field="description" header="Description" editor={editable ? (props) =>
              <InputText value={feeItems[props.rowIndex]?.description} onChange={(e) => handleInputChange(e, props.rowIndex, 'description')} />
              : null} />
            <Column field="price" header="Price" editor={editable ? (props) =>
              <InputText value={feeItems[props.rowIndex]?.price} onChange={(e) => handleInputChange(e, props.rowIndex, 'price')} />
              : null} />
            {editable && <Column body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} />}
          </DataTable>
        
    </>
  );
};

export default FeeItems;
